module.exports = __webpack_public_path__ + "static/media/anebyvapen.959ec423.png";